module.exports = __webpack_public_path__ + "static/media/connection-bg.8341ca63.jpg";